module.exports = __webpack_public_path__ + "static/media/allergen_lupin.e6f69126.e6f69126.png";